import { render } from "./OutstandingCoresModal.vue?vue&type=template&id=6ad2c326"
import script from "./OutstandingCoresModal.vue?vue&type=script&lang=js"
export * from "./OutstandingCoresModal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"OutstandingCoresModal.vue"]])

export default __exports__